import React from 'react';
import { languageService } from '../services/LanguageService';

var AppStore = require('./../store/appStore');
var AccountStore = require('./../store/accountStore');
var AppAction = require('./../action/appAction');

var LanguageDropdown = require('./languageDropdown');

var LanguageSelector = React.createClass({
  getInitialState: function () {
    return {
      languages: AppStore.getAvailableLanguages(),
      language: AppStore.getCurrentLanguage()
    }
  },

  componentWillMount(){
    AppStore.addChangeLangListener(this._onChange);
  },

  componentWillUnmount(){
    AppStore.removeChangeLangListener(this._onChange);
  },

  _onChange(){
    this.setState({
      languages: AppStore.getAvailableLanguages(),
      language: AppStore.getCurrentLanguage()
    });
  },

  render: function () {
    var {languages, language} = this.state;

    return (
      <LanguageDropdown
        className="header-dropdown-list"
        menuClass="pull-right"
        defaultValue={language.code}
        languages={languages}
        onChangeLanguage={this._selectLanguage}
      />
    )
  },

  _selectLanguage: function (language) {
    AppAction.setLanguage(language.code);
    languageService.setLanguageToSessionStorage(language.code, AccountStore.getAccount());
  }
});

module.exports = LanguageSelector;
